import React from "react";
import i18n from "../../../i18n";
import { Callout, Spinner } from "@blueprintjs/core";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import "chartjs-adapter-date-fns";
import PieChart from "../../Charts/PieChart";
import { MultiLineChart } from "../../Charts/LineChart";

export default class ResaRepartition extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      pieData: [],
      pieLabels: [],
      loading: false,
    };
    this.canvasRef = React.createRef();
  }

  async componentDidMount() {
    if (this.props.urlsearchparams !== undefined) {
      this.setState(
        {
          pieData: [],
          pieLabels: [],
          data: [],
          labels: [],
          loading: true,
        },
        () => {
          authenticatedGetFetch(
            "/activity/bookings/duration?" + this.props.urlsearchparams,
            (res) => {
              const labels = [];
              const datas = [];
              res.forEach((elm) => {
                labels.push(elm.range);
                datas.push(elm.sum);
              });
              this.setState(
                {
                  pieData: datas,
                  pieLabels: labels,
                },
                () => {
                  authenticatedGetFetch(
                    "/activity/bookings/planning?" + this.props.urlsearchparams,
                    (response) => {
                      this.setState({ dataset: response, loading: false });
                    }
                  );
                }
              );
            }
          );
        }
      );
    }
  }

  render() {
    return !this.props.urlsearchparams ? null : (
      <Callout title={<Trans>booking distribution</Trans>} icon="bookmark">
        <div className="flexbox-center">
          {this.state.loading ? (
            <Spinner />
          ) : this.state.dataset && this.state.dataset[0] ? (
            <div className="flexbox-center">
              <MultiLineChart
                format="date"
                stacked={true}
                datasets={this.state.dataset}
                labels={this.state.dataset[0]["labels"]}
                title={i18n.t("parking booked")}
              />
              {this.state.pieLabels.length > 0 && (
                <PieChart
                  labels={this.state.pieLabels}
                  data={this.state.pieData}
                  title={i18n.t("booking duration")}
                  legend={i18n.t("number of bookings by duration in days, upper limit included")}
                />
              )}
              <Callout intent="primary">
                <Trans>consider parkings booked per period, real parking data is available in other components as "booking" user type</Trans>
              </Callout>
            </div>
          ) : (
            <Callout intent="primary">
              <Trans>no booking on the selected period/park</Trans>
            </Callout>
          )}
        </div>
      </Callout>
    );
  }
}
